import type { EventsByDate, DynamicGroup } from '../../types/GroupsArrayType';
import type { GroupForAddDtstart } from '../../types/GroupsType';
import type { RowType, SingleEventByDate } from '../../types/RowType';
import generateRowId from '../helpers/generateRowId';
import getUniqueRowId from '../helpers/getUniqueRowId';

import getRowEvents from './getRowEvents';
import getRowHeight from './getRowHeight';

type Props = {
  events: EventsByDate;
  user: { id: number };
  group: GroupForAddDtstart | DynamicGroup;
  hasNameColumn?: boolean;
  eventHeight: number;
  rowIds: { [key in string]: boolean };
};
export default function getRegularRows({
  events,
  user,
  group,
  hasNameColumn = true,
  eventHeight,
  rowIds,
}: Props): Array<RowType> {
  const rows = [];
  const idPrefix = `RegularRow_${user.id}_${group.type}`;

  let rowEvents: SingleEventByDate;
  do {
    rowEvents = getRowEvents(events);
    if (Object.keys(rowEvents).length) {
      rows.push({
        id: getUniqueRowId(rowIds, generateRowId(idPrefix, rowEvents)),
        rowType: 'RegularRow',
        rowData: {
          events: rowEvents,
          size: getRowHeight(eventHeight),
          eventHeight,
          hasNameColumn,
          user,
          group,
        },
      });
    }
  } while (Object.keys(rowEvents).length);

  return rows;
}
